/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * @module enervee_utils.common
 */
autofocusDirective.$inject = [
    '$timeout',
    'UtilService'
];
function autofocusDirective (
    $timeout,
    UtilService
) {
    return {
        restrict: 'A',
        link: function autofocusLink(scope, elem, attrs) {
            scope.$watch(attrs.enerveeAutofocus, function (val) {
                if (angular.isDefined(val) && val) {
                    focusElement();
                }
            }, true);

            function focusElement() {
                $timeout(function () {
                    UtilService.focusElement(elem);
                }, 500);
            }
        }
    };
}

module.exports = autofocusDirective;